import { getProductTypeSingulars } from 'api/types/ReferenceData';
import { TFunction } from 'i18next';
import { RequestTypes } from 'types/ContactRequests';
import { ProductType } from 'types/Products';

export const getToolTip = (
  t: TFunction<'translation', undefined>,
  requestType: RequestTypes,
  productType: ProductType,
  authenticated: boolean,
  verified: boolean,
  outOfStock?: boolean
) => {
  if (!authenticated)
    return t(
      `actionButtons.${
        requestType === RequestTypes.CONTACT ? 'contact' : 'request'
      }.tooltips.disabled`,
      {
        type: requestType.toLowerCase(),
        productType: getProductTypeSingulars(productType).toLowerCase()
      }
    );
  else if (verified) {
    if (outOfStock) return t('actionButtons.request.tooltips.outOfStock');
    //user is authenticated and verified
    return t(
      `actionButtons.${
        requestType === RequestTypes.CONTACT ? 'contact' : 'request'
      }.tooltips.enabled`,
      {
        type: requestType.toLowerCase(),
        productType: getProductTypeSingulars(productType).toLowerCase()
      }
    );
  }
  //user is authenticated but still not verified
  else return t(`actionButtons.notVerified`);
};
